import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="top-right"
      richColors
      expand
      visibleToasts={3}
      gap={18}
      offset={64}
      {...props}
    />
  );
};

export { Toaster };
